import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { getActiveSummitDataOptions } from "~/lib/functions/summit";

const AgendaSearchSchema = z
  .object({
    am_id: z.string().optional(),
    live_id: z.string().optional(),
    session_id: z.string().optional(),
  })
  .passthrough();

/**
 * Legacy /summit/agenda route - redirects to the current summit's agenda.
 * Preserves backwards compatibility with existing links.
 */
export const Route = createFileRoute("/summit/agenda")({
  validateSearch: (search) => AgendaSearchSchema.parse(search ?? {}),
  beforeLoad: async () => {
    // Check auth - redirect to /summit/register if not authenticated
    const { fetchClerkAuth } = await import("~/routes/__root");
    const { userId } = await fetchClerkAuth();

    if (!userId) {
      throw redirect({ to: "/summit/register" });
    }
  },
  loader: async ({ context }) => {
    const summitData = await context.queryClient.ensureQueryData(
      getActiveSummitDataOptions,
    );

    if (!summitData?.summit?.id) {
      throw redirect({ to: "/summit/register" });
    }

    // Redirect to the summit-specific route under _user
    // Search params are automatically preserved by TanStack Router
    throw redirect({
      to: "/summit/$summitId/agenda",
      params: { summitId: summitData.summit.id },
    });
  },
});
